import { createStyles, makeStyles, TableCell, TableRow, Theme, withStyles } from '@material-ui/core';
import {
    ObtieneBeneficioAutomaticoPorRut,
    ObtieneEtapas,
    ObtieneInstrucciones,
    ObtienePostulaciones,
    ObtieneSiguienteEtapa,
    ObtieneBeneficioAutomatico,
    ObtieneCondiciones,
    ObtieneDeudaFinanciera,
    ObtieneDeudaBiblioteca,
    ObtieneDocumentoLEM,
    ObtienePostulacionesPostExt,
} from '../../../application/interactors/Postulante';

export const ObtienePostulacionesLogic = (
    selListaPostulaciones: any,
    headers: any,
    rut: number,
    anoProceso: number,
    periodoProceso: number,
    codigoNegocio: number,
    codigoPrograma?: string,
    codigoPlanificacion?: number,
    idPeriodo?: number
) => {
    codigoPrograma = codigoPrograma || ""; // Establecer "" como valor predeterminado
    idPeriodo = idPeriodo || 0; // Establecer 0 como valor predeterminado 
    codigoPlanificacion = codigoPlanificacion || 0; // Establecer 0 como valor predeterminado 
    return ObtienePostulaciones(selListaPostulaciones, rut, anoProceso, periodoProceso, codigoNegocio, codigoPrograma, codigoPlanificacion, idPeriodo, headers);
};

export const ObtienePostulacionesPostExtLogic = (
    selListaPostulaciones: any,
    headers: any,
    rut: number,
    pasaporte: string,
    anoProceso: number,
    periodoProceso: number,
    codigoNegocio: number,
    codigoPrograma: string,
    codigoPlanificacion: number,
    idPeriodo: number,
) => {
    idPeriodo = idPeriodo || 0; // Establecer 0 como valor predeterminado si idPeriodo no viene

    return ObtienePostulacionesPostExt(
        selListaPostulaciones,
        headers,
        rut,
        pasaporte,
        anoProceso,
        periodoProceso,
        codigoNegocio,
        codigoPrograma,
        codigoPlanificacion,
        idPeriodo,
    );
};

export const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

export const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

export const useStyles = makeStyles({
    table: {
        minWidth: 700,
    },
});

export const useStylesList = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
            maxWidth: 360,
            backgroundColor: theme.palette.background.paper,
        },
        panelCentral: {
            padding: theme.spacing(0),
            textAlign: 'center',
            marginBottom: theme.spacing(55),
        },
        buttonProgress: {
            color: theme.palette.primary.light,
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -12,
            marginLeft: -12,
        },
    }),
);
// export const ObtieneMayorEdadLogic = (selObtieneMayorEdad: any, rut: number, rutRF: number) => {
//   return ObtieneMayorEdad(selObtieneMayorEdad, rut, rutRF);
// }
export const ObtieneInstruccionesLogic = (
    selListaInstrucciones: any,
    codigoNegocio: number,
    codigoPrograma: string,
) => {
    return ObtieneInstrucciones(selListaInstrucciones, codigoNegocio, codigoPrograma);
};
export const ObtieneCondicionesLogic = (selListaInstrucciones: any, rut: number) => {
    return ObtieneCondiciones(selListaInstrucciones, rut);
};

export const ObtieneEtapasLogic = (
    selListaEtapas: any,
    codigoNegocio: number,
    codigoPrograma: string,
    CodigoPlanificacionAcademica: number,
    rut: number,
    año: number,
    periodo: number,
    debefirmar: boolean = false,
) => {
    return ObtieneEtapas(
        selListaEtapas,
        codigoNegocio,
        codigoPrograma,
        CodigoPlanificacionAcademica,
        rut,
        año,
        periodo,
        debefirmar,
    );
};
export const ObtieneSiguienteEtapaLogic = (selListaEtapas: any, contrato: boolean, pago: boolean) => {
    return ObtieneSiguienteEtapa(selListaEtapas, contrato, pago);
};

export const getToken = () => {
    let tokenString = sessionStorage.getItem('stage');
    if (tokenString === null) {
        tokenString = '';
    }
    const userStage = JSON.parse(tokenString);
    return userStage?.stage;
};
export const ObtieneBeneficioAutomaticoLogic = (selObtieneBeneficioAutomatico: any, headers: any, codNegocio: number, codPrograma: string) => {
    return ObtieneBeneficioAutomatico(selObtieneBeneficioAutomatico, headers, codNegocio, codPrograma);
};
export const ObtieneBeneficioAutomaticoPorRutLogic = (selListaBeneficiosPorRut: any, codCarr: string, codigoBeneficio: number, rut: number) => {
    return ObtieneBeneficioAutomaticoPorRut(selListaBeneficiosPorRut, codCarr, codigoBeneficio, rut);
};
export const ObtieneDeudaFinancieraLogic = (selListabeneficio: any, headers: any, rut: number) => {
    return ObtieneDeudaFinanciera(selListabeneficio, headers, rut);
};
export const ObtieneDeudaBibliotecaLogic = (selListabeneficio: any, rut: number, ano: number, periodo: number) => {
    return ObtieneDeudaBiblioteca(selListabeneficio, rut, ano, periodo);
};
export const ObtieneDocumentoLEMLogic = (selListabeneficio: any, rut: number, ano: number, periodo: number) => {
    return ObtieneDocumentoLEM(selListabeneficio, rut, ano, periodo);
};
